module.exports = __webpack_public_path__ + "img/GroupScheduleExams.150fe980.svg";